import { render, staticRenderFns } from "./add-shipping-information.vue?vue&type=template&id=1a353710&scoped=true&"
import script from "./add-shipping-information.vue?vue&type=script&lang=js&"
export * from "./add-shipping-information.vue?vue&type=script&lang=js&"
import style0 from "./add-shipping-information.vue?vue&type=style&index=0&id=1a353710&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a353710",
  null
  
)

export default component.exports